import React, { useState } from "react"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import GlobalHelper from "../../common/GlobalHelper"
import { AlertVariant } from "../../common/alert/Alert"
import Icon from "../../common/icon/icon.component"
import ProposalPreviewModal from "../../common/proposal/previewmodal.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component"
import QuoteEventsTimeLine from "../../quote/analytics/eventstimeline.component"
import AnalyticsQuoteEmails from "../../quote/analytics/quoteemails.component"
import { displayAlert } from "../../state/alert/reducer"
import Email from "../../state/proposal/Email"
import Proposal from "../../state/proposal/Proposal"
import { PROPOSAL_TYPE } from "../../state/proposal/ProposalType"
import AccountStatement from "./model/AccountStatement"



type OwnProps = {
    accountStatement: AccountStatement,
    proposal : Proposal,
    proposalEmails : Email[],
    refetchEmails : () => void
    isError : boolean,
    isLoading : boolean
}


const AccountStatementAnalytics = (props : OwnProps ) => {

    const dispatch = useDispatch()
    const accountStatement = props.accountStatement
    const proposal = props.proposal
    const proposalEmails = props.proposalEmails

    const [showModal, setShowModal] = useState(false)
    const [redirect, setRedirect] = useState<React.ReactNode>(null)

    const printPdf = (e: React.MouseEvent) =>   {
        e.preventDefault()
        GlobalHelper.redirectToPrintPdf(accountStatement.getPrintUrl())
    }


    const edit = (e : React.MouseEvent) => {
        e.preventDefault()
        setRedirect(
            <Redirect to={{
                pathname: "/proposals/" + accountStatement.getProposalHash() + "/preview",
                state: {
                    fromEditAccountStatement : true
                }
            }}/>
        )
    }

    if (props.isError) {
        dispatch(displayAlert({ type: AlertVariant.DANGER, message: "Error: Could not load proposal" }))
    }

    if (props.isLoading || !proposalEmails) {
        return <LoadingSpinner className="py-2" />
    }

    return  <>
        {showModal && <ProposalPreviewModal
            onClose={() => {
                setShowModal(false)
            }}
            hash={proposal.getProposalHash()}
            pdfLink={proposal.getPdfUri()}
            publicLink={proposal.getPublicLink()}
            proposalType={PROPOSAL_TYPE.ACCOUNT_STATEMENT}
        />}
        {redirect}
        <div className="col-12 ui-module">
            <div className={"row align-items-baseline justify-content-between px-3 d-flex"}>
                <div className={"px-3 mr-2 bg-secondary"}>
                    <div className={"w-100"}>
                        <label className="col-form-label custom-form-label pt-2 text-white">
                            <strong>
                                <FormattedMessage
                                    id="account-statement.analytics.balance_label"
                                    defaultMessage="Owing Balance"
                                />
                            </strong>
                        </label>
                    </div>
                    <h2 className={"m-0 text-white"}>
                        <FormattedNumber
                            value={proposal.getCustomerAccountGlobalBalance() <= 0 ?
                                proposal.getCustomerAccountOwingBalance() : -proposal.getCustomerAccountGlobalBalance()}
                            style={"currency"}
                            currency={accountStatement.getCurrency()}
                        />
                    </h2>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12"}>
                    <hr />
                </div>
            </div>
            <div className={"d-flex justify-content-end"}>
                <div className={"col-6"}>
                    <div >
                        <label className="col-form-label custom-form-label pt-2 mt-1">
                            <strong>
                                <FormattedMessage
                                    id="invoice.analytics.emails_label"
                                    defaultMessage="Emails"
                                />
                            </strong>
                        </label>
                    </div>
                    <AnalyticsQuoteEmails
                        proposal={proposal}
                        emails={proposalEmails}
                        isEditable={true}
                        onChange={() => {
                            props.refetchEmails()
                        }}
                    />
                </div>
            </div>
        </div>
        <div className={"col-12 px-0 mb-15"}>
            <QuoteEventsTimeLine accountStatement={accountStatement} proposal={proposal} emails={proposalEmails} proposalEmails={proposalEmails} />
        </div>
        <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
            <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
                <div className="col-12 ui-module sticky-bottom-module">
                    <div className="row justify-content-end">
                        <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                            <div className={"d-flex"}>
                                <div className={""}>
                                    <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={() => {
                                        setShowModal(true)
                                    }} >
                                        <Icon value={"eye"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="invoice.analytics.preview_btn"
                                            defaultMessage="Preview"
                                        />
                                    </button>
                                    <a className={"btn btn-sm btn-outline-primary mr-2 mb-2"}
                                        href={proposal.getPublicLink()}
                                        target={"_blank"} rel="noreferrer">
                                        <Icon value={"external-link-alt"}
                                            className={"mr-1"} />
                                        <FormattedMessage
                                            id="account_statement.analytics.open_account_statement_btn"
                                            defaultMessage="Open statement"
                                        />
                                    </a>
                                </div>
                                <div className="mr-2 mb-2 ">
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        type="button" id="dropdownMoreButton"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        disabled={false}>
                                        <Icon value={"ellipsis-h"} className={"mr-1"} />
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                        <a
                                            className="dropdown-item"
                                            href="#"
                                            onClick={printPdf}>
                                            <Icon value={"print"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="quote.analytics.print_btn"
                                                defaultMessage="Print"
                                            />
                                        </a>
                                        <a
                                            className="dropdown-item"
                                            href={"/proposals/" + accountStatement.getProposalHash() + "/preview"}
                                            onClick={edit}>
                                            <Icon value={"envelope"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="account_statement.analytics.edit"
                                                defaultMessage="Edit"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>

}

export default injectIntl(AccountStatementAnalytics)


// WEBPACK FOOTER //
// ./src/customer/account-statement/AccountStatementAnalytics.tsx